<template>
    <div id="home">
        <headerAside ref="headerAside"/>
        <div id="main">
            <keep-alive>
                <router-view v-slot="{ Component }" :key="$route.fullpath" v-if="$route.meta.keepAlive">
                    <component :is="Component"/>
                </router-view>
            </keep-alive>
            <router-view v-slot="{ Component }" :key="$route.fullpath" v-if="!$route.meta.keepAlive">
                <component :is="Component"/>
            </router-view>
        </div>
        <footerBar/>
    </div>
</template>

<script>
    import headerAside from "@/components/headerAside";
    import footerBar from "@/components/footerBar";

    export default {
        name: 'Home',
        components: {
            headerAside,
            footerBar
        },
        mounted() {
        },
        methods: {
            updateHeaderAside() {
                // this.$children[0].getUserInfo();
                this.$refs.headerAside.getUserInfo();
            }
        }
    }
</script>
<style lang="scss">
    @import "../assets/scss/base.scss";

    #main {
        margin-top: 66px;
        background: $colorH;
    }

    #home {
        position: relative;
    }
</style>
